import { render } from "./UsadosFilter.vue?vue&type=template&id=83c8a4ca"
import script from "./UsadosFilter.vue?vue&type=script&lang=js"
export * from "./UsadosFilter.vue?vue&type=script&lang=js"

import "./UsadosFilter.vue?vue&type=style&index=0&id=83c8a4ca&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__